class _api {
    #baseURL = '';
    #token = async () => '';
    #inc = () => console.warn('HTTP - No increase function!');
    #dec = () => console.warn('HTTP - No decrease function!');
    #messenger = () => console.warn('HTTP - No messenger function!')
    #progress = () => console.warn('HTTP - No progress handler!')
    #errorHandler = () => { }
    constructor() {
        console.log('### HTTP Class constructed');
    }

    registerBaseURL = (baseURL) => {
        this.#baseURL = `${window.location.protocol}//${window.location.hostname}baseUURL`;
    }
    registerNextURL = (baseURL) => {
        this.#baseURL = baseURL;
    }
    registerTrafficFunctions = (inc, dec) => {
        this.#inc = inc;
        this.#dec = dec;
    }
    registerTokenFunction = (token) => {
        this.#token = token;
    }
    registerMessengerFunction = (messenger) => {
        this.#messenger = messenger;
    }
    registerProgressFunction = (progress) => {
        this.#progress = progress;
    }
    registerErrorHandler = (errorHandler) => {
        this.#errorHandler = errorHandler;
    }

    async #header(method, url, body) {
        const options = {
            method: method,
            headers: body instanceof FormData ? {} : { 'Content-Type': 'application/json' },
            body: body instanceof FormData ? body : body ? JSON.stringify(body) : undefined,
        }
        options.headers['Authorization'] = `Bearer ${await this.#token()}`;
        return options;
    }

    async #fetcher(method, url, body) {
        const options = await this.#header(method, url, body);
        const res = await fetch(`${this.#baseURL}${url}`, options);
        if (!res.ok) {
            const errorText = await res.text();
            const error = new Error(errorText);
            error.status = res.status;
            throw error;
        }
        return res;
    }

    #error(err) {
        this.#errorHandler(err);
        this.#messenger(err);
        console.warn('HTTP Error', err.message ?? err);
        return null;
    }

    #builder(method, url, body) {
        return {
            json: async () => {
                this.#inc();
                try {
                    const res = await this.#fetcher(method, url, body);
                    const json = await res.json();
                    return json;
                } catch (err) {
                    return this.#error(err);
                } finally {
                    this.#dec();
                }
            },
            progress: async () => {
                this.#inc();
                try {
                    const res = await this.#fetcher(method, url, body);
                    if (!res.body) throw new Error('No response body');

                    const reader = res.body.getReader();
                    const decoder = new TextDecoder('utf-8');
                    let final;
                    let buffer = '';
                    while (true) {
                        const { value, done } = await reader.read();
                        buffer += decoder.decode(value, { stream: true });

                        let lines = buffer.split('\n');

                        // Keep the last part (may be incomplete) in buffer
                        buffer = lines.pop();

                        for (const line of lines) {
                            if (!line.trim()) continue; // skip empty lines
                            try {
                                const partial = JSON.parse(line.trim());
                                final = partial;
                                // if ('progress' in partial) store.set(_progress, partial);
                                if ('progress' in partial) this.#progress(partial);
                            } catch (err) {
                                throw new Error(line ?? 'Progress Error');
                                // this.#errorHandler(err);
                                console.warn('Error:', err.message);
                                return null;
                            }
                        }
                        if (done) break;

                    }
                    // console.log(`final is ${JSON.stringify(final)}`)
                    this.#progress(null);
                    return final;
                } catch (err) {
                    return this.#error(err);
                } finally {
                    this.#dec();
                }
            },
            blob: async () => {
                this.#inc();
                try {
                    const res = await this.#fetcher(method, url, body);
                    const contentDisposition = res.headers.get('Content-Disposition');
                    let filename = 'download.pdf'; // fallback

                    if (contentDisposition) {
                        const match = contentDisposition.match(/filename[^;=\n]*=["']?([^;"'\n]*)["']?/);
                        if (match && match[1]) {
                            filename = decodeURIComponent(match[1]);
                        }
                    }
                    console.log(filename);
                    const data = await res.blob();
                    return { blob: data, filename };
                } catch (err) {
                    return this.#error(err);
                } finally {
                    this.#dec();
                }
            },
            download: async () => {
                const res = await this.#builder(method, url, body).blob();
                const objectURL = URL.createObjectURL(res.blob);
                const a = Object.assign(document.createElement('a'), {
                    href: objectURL,
                    download: res.filename
                });
                a.click();
                URL.revokeObjectURL(objectURL);
            }
        }
    }

    get(url) { return this.#builder('GET', url) }
    put(url, body) { return this.#builder('PUT', url, body) }
    post(url, body) { return this.#builder('POST', url, body) }
    delete(url) { return this.#builder('DELETE', url) }
}
const http = new _api();
export default http;